enum CycleStatus {
  InActive = 'inactive',
  Active = 'active',
  Completed = 'completed',
}

export default CycleStatus;